import React from "react";
import DigitalProjectsGrid from "../common_components/DigitalProjectsGrid";
import CmykMarkSpread from "../common_components/design_components/CmykMarkSpread";
import "../styles/DigitalProjects.scss";

const DigitalProjects = () => {
  return (
    <div className="digital-projects">
      {/* Header Section */}
      <header className="header">
        <h1 className="title">DIGITAL</h1>
        <span className="cymk-mark-spread-container">
          <CmykMarkSpread />
        </span>
        <h1 className="title">PROJECTS</h1>
      </header>

      {/* Grid Section */}
      <div className="grid-layout">
        <DigitalProjectsGrid />
      </div>
    </div>
  );
};

export default DigitalProjects;
